import { useEffect, useState } from "react";
import { fetchCampaignBuilderCampaign, sendCampaignToContacts } from "./campaignBuilderApi";
import "./CampaignBuilderScreen.css";

export function ContactSendModal({
  contactId,
  email,
  campaignId,
  onClose,
}: {
  contactId: string;
  email: string;
  campaignId: string;
  onClose: () => void;
}) {
  const [steps, setSteps] = useState<Record<string, unknown>[]>([]);
  const [stepId, setStepId] = useState("");
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    void fetchCampaignBuilderCampaign(campaignId)
      .then((data) => setSteps((data.journey_steps as Record<string, unknown>[]) ?? []))
      .catch(() => setSteps([]));
  }, [campaignId]);

  async function onSend() {
    if (!stepId) return;
    setBusy(true);
    try {
      await sendCampaignToContacts(stepId, [contactId], { [contactId]: email });
      setMessage("Send queued (test mode routes to configured test address).");
    } catch (err: unknown) {
      setMessage(err instanceof Error ? err.message : "Send failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true">
      <div className="modal-card">
        <h3>Send communication</h3>
        <p className="hint">{email}</p>
        <select value={stepId} onChange={(e) => setStepId(e.target.value)} aria-label="Journey step">
          <option value="">Select journey step</option>
          {steps.map((s) => (
            <option key={String(s.step_id)} value={String(s.step_id)}>{String(s.name)}</option>
          ))}
        </select>
        <div className="campaign-builder-actions">
          <button type="button" disabled={busy || !stepId} onClick={() => void onSend()}>Send</button>
          <button type="button" onClick={onClose}>Cancel</button>
        </div>
        {message ? <p>{message}</p> : null}
      </div>
    </div>
  );
}
